<template>
  <div>
    <template v-if="importLoaded">
      <portal to="houseImporterPageTitle">
        {{pageTitle}}
        <div style="font-size: 12px; font-weight: 600; text-transform: uppercase; color: rgba(var(--app-warning), 1); line-height: 1.1">
          &lt;{{importInfo.db_connection}}&gt; <span style="color: rgba(var(--app-primary), 1)">{{getFullAddress(importInfo.address)}}</span>
        </div>
      </portal>

      <portal to="houseImporterHeaderCenter" v-if="importStage !== 5">
        <div class="house-import-stage-status">
          {{importInfo.status}}
        </div>
        <div class="house-import-stage-progress">
          <div class="house-import-stage-progress__text">{{importInfo.stage_progress | numberWithSpaces}}/{{importInfo.stage_total | numberWithSpaces}}</div>
          <vs-progress style="height: 16px" :percent="100 * (Number(importInfo.stage_progress) / Number(importInfo.stage_total))" color="warning" class="house-import-stage-progress__progress"/>
        </div>
      </portal>

      <ImportSourceStageMain v-if="importStage === 0" :importId="importId" :importInfo="importInfo"/>
      <CheckSourceStage v-else-if="importStage === 1" :importId="importId" :importInfo="importInfo"/>
      <ImportProdStage v-else-if="importStage === 2" :importId="importId" :importInfo="importInfo"/>
      <ImportFinanceStage v-else-if="importStage === 3" :importId="importId" :importInfo="importInfo" @update-stage="getImport()"/>
      <ImportChargesStage v-else-if="importStage === 4" :importId="importId" :importInfo="importInfo" @update-stage="getImport()"/>
      <ImportFinishedStage v-else-if="importStage === 5" :importId="importId" :importInfo="importInfo"/>

      <ImportComments :importInfo="importInfo"/>

    </template>
  </div>
</template>

<script>
  import ImportSourceStageMain from "@/components/house-importer/import-sourse-stage/ImportSourceStageMain";
  import CheckSourceStage from "@/components/house-importer/import-sourse-stage/CheckSourceStage";
  import ImportProdStage from "@/components/house-importer/import-prod-stage/ImportProdStage";
  import ImportFinanceStage from "@/components/house-importer/import-finance-stage/ImportFinanceStage";
  import ImportChargesStage from "@/components/house-importer/import-charges-stage/ImportChargesStage";
  import ImportFinishedStage from "@/components/house-importer/import-finished-stage/ImportFinishedStage";
  import ImportComments from "@/components/house-importer/import-comments/ImportComments";

  const PAGE_TITLES = {
    0: 'Импорт в промежуточную базу',
    1: 'Проверка промежуточной базы',
    2: 'Перенос в прод базу',
    3: 'Сведение финансовой информации',
    4: 'Сведение начислений',
    5: 'Импорт завршен',
  };



  export default {
    name: "ImportStagePage",
    components: {
      ImportSourceStageMain,
      CheckSourceStage,
      ImportProdStage,
      ImportFinanceStage,
      ImportChargesStage,
      ImportFinishedStage,
      ImportComments
    },
    data() {
      return {
        importLoaded: false,
        importInfo: null,
        importTimer: null,
      }
    },
    computed: {
      importId(){
        let id =  Number(this.$route.params.id);
        return !isNaN(id) ? id : null;
      },
      importStage(){
        let stage = Number(this.$route.params.stage);
        return !isNaN(stage) ? stage : null;
      },
      pageTitle(){
        return PAGE_TITLES[this.importStage] || 'Неизвестно';
      }
    },
    methods: {
      getFullAddress(data){
        return Object.values(data).join(', ');
      },
      setImportTimer(){
        this.importTimer = setInterval(() => {
          this.getImport();
        }, 10000);
      },
      clearImportTimer(){
        clearInterval(this.importTimer);
        this.importTimer = null;
      },
      async getImport(){
        try {
          let {data} = await this.$http.get('import/houses', {
            params: {
              id: this.importId
            }
          });

          if(!data.id){
            this.$router.replace({name: 'houseImporter404', params: {text: 'Импорт не найден'}});
          }
          else if(this.importStage !== data.stage){
            this.$router.replace({
              params: {
                id: data.id,
                stage: data.stage
              }
            })
          }

          this.importInfo = data;
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally {
          this.$nextTick(() => {
            this.importLoaded = true;
          });
        }
      }
    },
    created() {
      this.getImport();
      this.setImportTimer();
    },
    beforeDestroy() {
      this.clearImportTimer();
    },
    watch: {
      importId(){
        this.getImport();
      }
    }
  }
</script>

<style lang="scss">
  .house-import-stage-progress{
    position: relative;
    display: flex;
    width: 270px;
    margin: 5px auto 0;

    &__text{
      line-height: 1;
      position: absolute;
      z-index: 1000;
      width: 100%;
      text-align: center;
      font-size: 12px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .house-import-stage-status{
    line-height: 1.1;
    max-width: 290px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;
  }
</style>